import { IApplicationState } from '../../types/redux';

export function getBlackFridayUrl(state: IApplicationState): string {
  return state.config.newbuildingBlackFriday.url ?? /* istanbul ignore next */ '';
}
